import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCitiesByCountry = (country, cities) => {
  return {
    type: actionTypes.SET_CITIES_BY_COUNTRY,
    payload: { country, cities }
  }
}
